import { iconList } from './iconList';
import { IconName } from './types';

// A helper that should find an icon from iconList in case if we rename smth
const findIcon = (desiredIcon: IconName): IconName => {
  if (desiredIcon in iconList) {
    return desiredIcon;
  }

  const icons = Object.keys(iconList) as IconName[];
  const iconFromTheList = icons.find(
    (icon) => icon === desiredIcon || icon.startsWith(desiredIcon),
  );
  return iconFromTheList || 'chart-line';
};

export default findIcon;
